function base64ToBlob (base64, mimeType) {
    const encoded = base64.replace(/^data:[^,]*;base64,/, '');
    const byteCharacters = atob(encoded);
    const bytes = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        bytes[i] = byteCharacters.charCodeAt(i);
    }
    return new Blob([bytes], { type: mimeType });
}

function triggerDownload (url, filename) {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export function downloadBase64File (filename, base64) {
    triggerDownload(URL.createObjectURL(base64ToBlob(base64, 'application/octet-stream')), filename);
}

export function downloadBlobUrl (filename, url) {
    triggerDownload(url, filename);
}
